export const FETCHER_GET = 'GET';
export const FETCHER_POST = 'POST';
export const FETCHER_PATCH = 'PATCH';
export const FETCHER_DELETE = 'DELETE';
